import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import BlogPostComponent from '../components/blog-post/blog-post.component';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';


let currentChange: any = {}
const BlogPostContainer = ({ onSubmit, cardDetailInfo }: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dispatch = useAppDispatch()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [
    selectedBlog,
    setSelectedBlog
  ] = useState<any>({})
  const [
    blogPostImageIndex,
    setBlogPostImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedBlog({ ...selectedBlog, [field]: event });
  }

  useEffect(
    () => {
      if (cardDetailInfo) {
        setSelectedBlog(cardDetailInfo)
        const BlogPostItemsData: any = cardDetailInfo?.BlogPostDocumentURLs?.map((item: any) => {
          const itemData = {
            Id: item?.Id || 0,
            BlogPostId: item?.BlogPostId || selectedBlog?.Id || 0,
            FileTypeId: item?.FileTypeId,
            FileMappingURL: item?.BlogPostFileURL
          }
          return itemData
        })
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: BlogPostItemsData });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
      else {
        setIsLoading(false)
      }
    },
    [cardDetailInfo]
  )

  const getIsImageRecordDeletable = (idx: any) => {
    if (mediaFiles.length - 1 === idx) {
      return false
    }
    return true
  }
  const handleFormSubmit = async (event: any) => {
    mediaFiles?.splice(
      mediaFiles.length - 1,
      1
    )
    const BlogPostFileData: any = mediaFiles?.map((item: any) => {
      const itemData = {
        Id: item?.Id || 0,
        BlogPostId: selectedBlog?.Id,
        FileTypeId: item?.FileTypeId,
        BlogPostFileURL: item?.FileMappingURL
      }

      return itemData
    })
    selectedBlog.BlogPostDocumentURLs = BlogPostFileData
    onSubmit(selectedBlog)

  }
  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      BlogPostId: selectedBlog?.Id,
      FileTypeId: 0,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileMappingURL !== ''
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileMappingURLDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    console.log(idx, templateField, fileType, 'vjvjhjhb')
    setBlogPostImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'BlogPost',
      type: fileType
    })
    console.log(openFile, 'ghghkjk')
  }
  const handleSubmit = (data: any) => {

    mediaFiles[blogPostImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }

  useEffect(
    () => {
      if (currentChange.field === 'BlogPostFileURL') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )

  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
      />}
      {isLoading ? <PageLoader /> :
        <BlogPostComponent
          handleInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          selectedBlog={selectedBlog}
          mediaFiles={mediaFiles}
          handleFormItemChange={handleFormItemChange}
          getIsImageRecordDeletable={getIsImageRecordDeletable}
          changeImage={changeImage}
        />
      }

    </>
  )

}

export default BlogPostContainer;
